module.exports = __webpack_public_path__ + "img/4.87e04f57.png";